import React, { useEffect } from "react";
import { authDataService } from "src/app/services/data/auth.data.service";
import { UserRole } from "src/app/@types/enums/user.roles";

interface ThemeOverrideProps {
  currentTheme: string;
}

interface ProgramThemes {
  [key: string]: string;
}

const ThemeOverride: React.FC<ThemeOverrideProps> = ({ currentTheme }) => {
  const programThemes: ProgramThemes = {
    summer: "rgba(32, 36, 65, 1)",
    inschool: "rgba(17, 83, 83, 1)",
    leadership: "rgba(55, 20, 60, 1)",
  };

  useEffect(() => {
    if (authDataService.userRoleId === UserRole.Youth) {
      setTimeout(() => {
        // Apply theme to navbar
        const navbarElements = document.querySelectorAll(".navbar-style1-root");
        navbarElements.forEach((element) => {
          if (element instanceof HTMLElement) {
            element.style.backgroundColor = programThemes[currentTheme] || "";
          }
        });

        // Apply same theme to footer
        const footerElement = document.getElementById("fuse-footer");
        if (footerElement) {
          footerElement.style.backgroundColor =
            programThemes[currentTheme] || "";
        }
      }, 50);
    }
  }, [currentTheme]);

  return null;
};

export default ThemeOverride;
